import { Entity } from '../types/simulation';
import { calculateDistance, formatNumber } from '../utils/mathHelpers';
import './EntityList.css';

interface EntityListProps {
  entities: Entity[];
  myEntityId: string | null;
  onRefresh: () => void;
}

export function EntityList({ entities, myEntityId, onRefresh }: EntityListProps) {
  const myEntity = entities.find((e) => e.id === myEntityId);

  return (
    <div className="entity-list">
      <div className="entity-list-header">
        <h3>Entities ({entities.length})</h3>
        <button onClick={onRefresh} className="refresh-btn" title="Refresh entity list">
          🔄
        </button>
      </div>

      <div className="entities">
        {entities.length === 0 && (
          <div className="no-entities">No entities connected</div>
        )}

        {entities.map((entity) => {
          const isMe = entity.id === myEntityId;
          const distance = myEntity && !isMe
            ? calculateDistance(myEntity.position, entity.position)
            : 0;

          return (
            <div key={entity.id} className={`entity-item ${isMe ? 'me' : ''}`}>
              <div className="entity-name">
                {entity.id}
                {isMe && <span className="me-badge">You</span>}
              </div>
              <div className="entity-info">
                <div className="position">
                  Position: ({formatNumber(entity.position.x)}, {formatNumber(entity.position.y)}, {formatNumber(entity.position.z)})
                </div>
                {!isMe && myEntity && (
                  <div className="distance">
                    Distance: {formatNumber(distance)} units
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
